import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import MethodePage from "@/pages/MethodePage";
import { MentionsLegales, Confidentialite } from "@/pages/Legal";
import ServicePage from "@/pages/ServicePage";
import { SEO_PAGES } from "@/data/seoPages";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="App grain" data-testid="app-root">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/methode" element={<MethodePage />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<JournalArticle />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            {SEO_PAGES.map((p) => (
              <Route
                key={p.slug}
                path={`/${p.slug}`}
                element={<ServicePage page={p} />}
              />
            ))}
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
